import { createEntityActions, createListActions, IAction } from '@aston/foundation';
import { createAction, props } from '@ngrx/store';
import { ISubsidiaryDetail, ISubsidiaryForm } from 'apps/console/src/app/subsidiaries-module/models';
import { IFilter, ActionType } from '@aston/foundation';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ISubsidiaryUser, IDelegationStatus, IUsersList, UsersListSortProp, UserStatus, UserRole, ISubsidiaryAppliedUserDelegations, ISubsidiaryFormUserDelegations, ISubsidiaryFormUserInactivity } from '@aston/middle-users-admin';


const ActionPrefix = 'SubsidiaryDetail';

export const ToggleIsEditingSubsidiary = createAction(`[${ActionPrefix}] Toggle Is Editing Subsidiary`);

export const SetActiveModal = createAction(`[${ActionPrefix}] SetActiveModal`, props<{ modal: NgbModalRef }>());

export const OpenSubsidiaryUserForm = createAction(`[${ActionPrefix}] OpenSubsidiaryUserForm`);

export const OpenUserDelegationView = createAction(`[${ActionPrefix}] OpenUserDelegationView`, props<{ user: ISubsidiaryUser }>());

export const OpenUserDelegationForm = createAction(`[${ActionPrefix}] OpenUserDelegationForm`, props<{ user: ISubsidiaryUser, currentUser: ISubsidiaryUser, mode: ActionType }>());

export const OpenUserInactivityForm = createAction(`[${ActionPrefix}] OpenUserInactivityForm`, props<{ user: ISubsidiaryUser, mode: ActionType }>());

export const displayEmailAlreadyExistInGuestListError = createAction(`[${ActionPrefix}] display Email Already Exist In Guest List Error`);

export const displayEmailAlreadyExistInUserListError = createAction(`[${ActionPrefix}] display Email Already Exist Error`);

export const StartUserStatusWorkflow = createAction(`[${ActionPrefix}] Start User Status Workflow`, props<{ action: IAction, status: IDelegationStatus }>());

export const createSubsidiaryUserActions = createEntityActions<any>(ActionPrefix, 'Create subsidiary user');
export const {
	CreateEntityRequest: CreateSubsidiaryUserRequest,
	CreateEntitySuccess: CreateSubsidiaryUserSuccess,
	CreateEntityFailure: CreateSubsidiaryUserFailure,
} = createSubsidiaryUserActions;

export const CurrentSubsidiaryActions = createEntityActions<ISubsidiaryDetail>(ActionPrefix, 'Current Subsidiary');
export const {
	LoadEntityByIdRequest: LoadSubsidiaryRequest,
	LoadEntitySuccess: LoadSubsidiarySuccess,
	LoadEntityFailure: LoadSubsidiaryFailure
} = CurrentSubsidiaryActions;

export const UpdateSubsidiaryActions = createEntityActions<ISubsidiaryForm>(ActionPrefix, 'Update Subsidiary');
export const {
	UpdateEntityRequest: UpdateSubsidiaryRequest,
	UpdateEntitySuccess: UpdateSubsidiarySuccess,
	UpdateEntityFailure: UpdateSubsidiaryFailure
} = UpdateSubsidiaryActions;


export const usersListActions = createListActions<IUsersList, UsersListSortProp, IFilter>(ActionPrefix, 'Users List');
export const {
	LoadListRequest: LoadUsersListRequest,
	LoadListSuccess: LoadUsersListSuccess,
	LoadListFailure: LoadUsersListFailure,
	ListSettings: UpdateUsersListSettings,
} = usersListActions;


export const UpdateTransientUserStatusActions = createEntityActions<{ userId: number, userStatus: UserStatus, wasDelegating?: boolean, wasDelegated?: boolean }>(ActionPrefix, 'Update TransientUserStatus');
export const {
	UpdateEntityRequest: UpdateTransientUserStatusRequest,
	UpdateEntitySuccess: UpdateTransientUserStatusSuccess,
	UpdateEntityFailure: UpdateTransientUserStatusFailure
} = UpdateTransientUserStatusActions;

export const UpdateTransientSubsidiaryRoleActions = createEntityActions<{ userId: number, subsidiaryRole: UserRole }>(ActionPrefix, 'Update TransientSubsidiaryRole');
export const {
	UpdateEntityRequest: UpdateTransientSubsidiaryRoleRequest,
	UpdateEntitySuccess: UpdateTransientSubsidiaryRoleSuccess,
	UpdateEntityFailure: UpdateTransientSubsidiaryRoleFailure
} = UpdateTransientSubsidiaryRoleActions;


export const ResentUserInvitationActions = createEntityActions<{ userId: number}>(ActionPrefix, 'Resent User Invitation');
export const {
	UpdateEntityRequest: ResentUserInvitationRequest,
	UpdateEntitySuccess: ResentUserInvitationSuccess,
	UpdateEntityFailure: ResentUserInvitationtFailure
} = ResentUserInvitationActions;

export const LoadAvailableRolesForCurrentSubsidiaryActions = createEntityActions<string[]>(ActionPrefix, 'Load SubsidiaryRoles');
export const {
	LoadEntityRequest: LoadAvailableRolesForCurrentSubsidiaryRequest,
	LoadEntitySuccess: LoadAvailableRolesForCurrentSubsidiarySuccess,
	LoadEntityFailure: LoadAvailableRolesForCurrentSubsidiaryFailure
} = LoadAvailableRolesForCurrentSubsidiaryActions;

export const subsidiaryUserDelegationActions = createEntityActions<ISubsidiaryAppliedUserDelegations>(ActionPrefix, 'Subsidiary User Delegations');
export const {
	LoadEntityByIdRequest: LoadSubsidiaryUserDelegationsRequest,
	LoadEntitySuccess: LoadSubsidiaryUserDelegationsSuccess,
	LoadEntityFailure: LoadSubsidiaryUserDelegationsFailure,
} = subsidiaryUserDelegationActions;

export const subsidiaryUserDelegationFormActions = createEntityActions<ISubsidiaryFormUserDelegations>(ActionPrefix, 'Subsidiary User Delegations Form');
export const {
	LoadEntityByIdRequest: LoadSubsidiaryUserDelegationsFormRequest,
	LoadEntitySuccess: LoadSubsidiaryUserDelegationsFormSuccess,
	LoadEntityFailure: LoadSubsidiaryUserDelegationsFormFailure,
	UpdateEntityRequest: UpdateSubsidiaryUserDelegationsFormRequest,
	UpdateEntitySuccess: UpdateSubsidiaryUserDelegationsFormSuccess,
	UpdateEntityFailure: UpdateSubsidiaryUserDelegationsFormFailure,
} = subsidiaryUserDelegationFormActions;

export const UpdateSubsidiaryDelegatedUsersDelegationsRequest = createAction(`${ActionPrefix} Update Subsidiary Delagated Users Delegations`, props<{ userId: number }>());

export const subsidiaryUserInactivityFormActions = createEntityActions<ISubsidiaryFormUserInactivity>(ActionPrefix, 'Subsidiary User Inactivity Form');
export const {
	UpdateEntityRequest: UpdateSubsidiaryUserInactivityFormRequest,
	UpdateEntitySuccess: UpdateSubsidiaryUserInactivityFormSuccess,
	UpdateEntityFailure: UpdateSubsidiaryUserInactivityFormFailure,
} = subsidiaryUserInactivityFormActions;
